import moment from "moment";
import { combineReducers } from "redux";
import { reportsConstants } from "../../actions/reports";
import { balanceConstants } from "../../actions/reports/balance";
import { ledgerConstants } from "../../actions/reports/balance/ledger";
import { GET_VAT_ENTRIES_SUCCESS } from "../../actions/reports/vatEntries";
import { vatSettlementConstants } from "../../actions/reports/vatSettlement";

const defSearch = {
  status: {
    started: false,
    ended: false,
    error: false
  },
  parameters: {},
  report: {},
  details: [],
  additionalData: {}
};

function search(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defSearch : state;
  let tmpAdditionalData;
  switch (type) {
  case balanceConstants.GET_BALANCE_READ_START:
    return {
      report: {},
      parameters: payload.parameters,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case balanceConstants.GET_BALANCE_READ_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      report: payload.data,
      parameters: payload.parameters
    };
  case balanceConstants.GET_BALANCE_READ_ERROR:
    return {
      report: {},
      parameters: [],
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case ledgerConstants.GET_ENTRIES_READ_START:
    tmpAdditionalData = { ...state.additionalData };
    delete tmpAdditionalData["balanceDetails"];
    return {
      report: state.report,
      additionalData: tmpAdditionalData,
      parameters: payload.parameters,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case ledgerConstants.GET_ENTRIES_READ_SUCCESS:
    return {
      report: state.report,
      parameters: state.parameters,
      additionalData: {
        ...state.additionalData,
        balanceDetails: payload
      },
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case ledgerConstants.GET_ENTRIES_READ_ERROR:
    tmpAdditionalData = { ...state.additionalData };
    delete tmpAdditionalData["balanceDetails"];
    return {
      report: state.report,
      parameters: state.parameters,
      additionalData: tmpAdditionalData,
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case vatSettlementConstants.VATSETTLEMENT_RATES_READ_SUCCESS:
    return {
      parameters: state.parameters,
      report: state.report,
      additionalData: {
        ...state.additionalData,
        vatSettlementRates: payload
      },
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case balanceConstants.CLEAR_SEARCH_PARAMETERS:
    return {
      ...defaultS,
      parameters: {}
    };
  case reportsConstants.CLEAR_REPORT_SEARCH_DATA:
    return defSearch;
  case vatSettlementConstants.CLEAR_VATSETTLEMENT_DETAILS_DATA:
    tmpAdditionalData = { ...state.additionalData };
    delete tmpAdditionalData["vatSettlementDetails"];
    return {
      report: state.report,
      additionalData: tmpAdditionalData,
      parameters: state.parameters,
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case ledgerConstants.CLEAR_ENTRIES_PARAMETERS:
    tmpAdditionalData = { ...state.additionalData };
    delete tmpAdditionalData["balanceDetails"];
    return {
      report: state.report,
      additionalData: tmpAdditionalData,
      parameters: state.parameters,
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  default:
    return defaultS;
  }
}

function vat(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {
    status: {
      started: true,
      error: false,
      ended: false
    },
    statusDetail: {
      started: true,
      error: false,
      ended: false
    }
  } : state;

  switch (type) {
  case vatSettlementConstants.WORKSPACE_SETTLEMENT_READ_ERROR:
    return {
      ...state,
      settlements: [],
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case vatSettlementConstants.WORKSPACE_SETTLEMENT_READ_START:
    return {
      ...state,
      settlements: [],
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case vatSettlementConstants.WORKSPACE_SETTLEMENT_READ_SUCCESS:    
  /** TODO rimuovere 
    
    const clone = {...payload.data};
    
    clone.settlementApiResList[9].businessSettlements.push(clone.settlementApiResList[9].businessSettlements[0]);
    */  
    return {
      ...state,
      settlements: payload.data, // clone,
      parameters: payload.parameters,
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case vatSettlementConstants.VATSETTLEMENT_OPEN_PERIOD_START:
            
    return {
      ...state,
      statusDetail: {
        started: true,
        error: false,
        ended: false
      }
    };

  case vatSettlementConstants.VATSETTLEMENT_OPEN_PERIOD_SUCCESS:
    const cloneSettlements = {...state.settlements};
    
    cloneSettlements.settlementApiResList = cloneSettlements.settlementApiResList.map(o => {
      if (o.settlementId === payload)
        o.closed = false;
      return o;
    });              
    return {
      ...state,
      settlements: cloneSettlements      
    };
  case vatSettlementConstants.VATSETTLEMENT_CLOSE_PERIOD_SUCCESS:
    const cloneSettlementsList = {...state.settlements};
    
    cloneSettlementsList.settlementApiResList = cloneSettlementsList.settlementApiResList.map(o => {
      if (o.month === moment(payload.parameters.ordinal,"MMMM").format("M"))
        o.closed = true;
      return o;
    });              
    return {
      ...state,
      settlements: cloneSettlementsList      
    };
  case vatSettlementConstants.VATSETTLEMENT_READ_START:
    return {
      ...state,
      detail: {},
      statusDetail: {
        started: true,
        error: false,
        ended: false
      }
    };
  case vatSettlementConstants.VATSETTLEMENT_READ_SUCCESS:
    return {
      ...state,
      detail: payload.data,
      statusDetail: {
        started: false,
        error: false,
        ended: true
      }
    };
  case vatSettlementConstants.VATSETTLEMENT_READ_ERROR:
    return {
      ...state,
      detail: payload.data,
      statusDetail: {
        started: false,
        error: true,
        ended: false
      }
    };
  case vatSettlementConstants.VATSETTLEMENT_DETAILS_READ_START:
    return {
      ...state,
      aliquoteDetail: [],
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case vatSettlementConstants.VATSETTLEMENT_DETAILS_READ_SUCCESS:
    return {
      ...state,
      aliquoteDetail: payload,
      report: state.report,
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case vatSettlementConstants.VATSETTLEMENT_DETAILS_READ_ERROR:
    return {
      ...state,
      aliquoteDetail: [],
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function vatEntries(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {status: {
    started: false,
    error: false,
    ended: false
  }} : state;
  switch (type) {
  case GET_VAT_ENTRIES_SUCCESS:
    return {
      data: [{
        id: "1",
        registrationDate: "2023-01-12",
        docType: "Fattura di vendita",
        vatType: "Fattura a esig. diff. Art.32 bis DL83/2012",
        docNumber: "12345",
        docDate: "2023-01-12",
        customerOrSupplier: "La Spiga panificio srl",
        vatNumberOrTaxId: "987654321",
        aliquote: "",
        hasMultipleAliquotes: true,
        taxable: 120,
        tax: 20,
        total: 140,
        registrationId: "21963e0e-6939-4716-96d1-6365c58757c7"
      }, {
        id: "1",
        registrationDate: "2023-02-12",
        docType: "Fattura di acquisto",
        vatType: "Fattura a esig. diff. Art.32 bis DL83/2012",
        docNumber: "123123",
        docDate: "2023-02-12",
        customerOrSupplier: "La Spiga panificio srl",
        vatNumberOrTaxId: "987654321",
        aliquote: "22",
        hasMultipleAliquotes: false,
        taxable: 100,
        tax: 50,
        total: 150,
        registrationId: "21963e0e-6939-4716-96d1-6365c58757c7"
      }],
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  default:
    return defaultS;
  }
}

export const reports = combineReducers({
  search,
  vat,
  vatEntries
});

export default reports;
